var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container pa-0 ma-0"},[_c('v-expand-x-transition',[_c('landing-toolbar')],1),_c('v-container',[_c('gestion-tiempos')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }